const localizers = {
  'loading.msg': () => `Carregando...`,
  'SASServer.genericError.msg': () => `O servidor não pode ser alcançado.`,
  'SASReport.genericError.msg': () => `Não foi possível carregar o relatório selecionado.`,
  'SASReportImage.genericError.msg': () => `A imagem do relatório falhou ao carregar.`,
  'SASReportImage.imageNotSupported.msg': () => `As imagens não são compatíveis com este tipo de conteúdo de relatório.`,
}
export default localizers;
